/** A closed native dialog sometimes never replies; don't leave its UI busy forever. */
export const bridgeTimeout = (operation, timeoutMs = 60_000) => new Promise((resolve, reject) => {
    const timer = globalThis.setTimeout(() => reject(new Error('Платформа не ответила. Попробуйте ещё раз.')), timeoutMs);
    void operation.then((value) => {
        globalThis.clearTimeout(timer);
        resolve(value);
    }, (error) => {
        globalThis.clearTimeout(timer);
        reject(error instanceof Error
            ? error
            : Object.assign(new Error('Ошибка платформы'), typeof error === 'object' && error ? error : {}));
    });
});
